//src/components/ResetPassword.js

import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const ResetPassword = () => {
    const [formData, setFormData] = useState({
        password: '',
        password2: '',
    });
    const [message, setMessage] = useState('');
    const { token } = useParams();
    const navigate = useNavigate();

    const { password, password2 } = formData;

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        if (password !== password2) {
            setMessage('Les mots de passe ne correspondent pas.');
            return;
        }

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            const body = JSON.stringify({ password });
            const res = await axios.post(`https://api.blackroq.pro/api/auth/reset-password/${token}`, body, config);
            
            setMessage(res.data.msg);
            setTimeout(() => {
                navigate('/login');
            }, 3000); // Redirige l'utilisateur vers la page de connexion après 3 secondes
        } catch (err) {
            console.error(err.response.data);
            setMessage(err.response.data.msg || 'Une erreur est survenue. Veuillez réessayer.');
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow p-4">
                        <h1 className="text-center mb-4">Réinitialiser le mot de passe</h1>
                        {message && (
                            <div className={`alert ${message.includes('succès') ? 'alert-success' : 'alert-danger'}`}>
                                {message}
                            </div>
                        )}
                        <form onSubmit={onSubmit}>
                            <div className="mb-3">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Nouveau mot de passe"
                                    name="password"
                                    value={password}
                                    onChange={onChange}
                                    required
                                    minLength="6"
                                />
                            </div>
                            <div className="mb-3">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Confirmer le nouveau mot de passe"
                                    name="password2"
                                    value={password2}
                                    onChange={onChange}
                                    required
                                    minLength="6"
                                />
                            </div>
                            <div className="d-grid gap-2">
                                <button type="submit" className="btn btn-primary">Réinitialiser le mot de passe</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;